import React, {
  Dispatch,
  SetStateAction,
} from 'react';
import { useIntl } from 'react-intl';

import { ButtonVariant } from '@/core/components/Button/Button.types';
import { contactMessages } from '@/core/messages/contact.messages';

import {
  Heading,
  Paragraph,
  StyledButton,
  Wrapper,
} from './ContactSuccess.styles';

type Props = {
  setIsFormSubmitted: Dispatch<SetStateAction<boolean>>;
}

export const ContactSuccess = ({ setIsFormSubmitted }: Props) => {
  const { formatMessage } = useIntl();

  return (

    <Wrapper>
      <Heading>{formatMessage(contactMessages.headingSuccess)}</Heading>
      <Paragraph>{formatMessage(contactMessages.successMessage)}</Paragraph>
      <StyledButton
        variant={ButtonVariant.PRIMARY}
        label={formatMessage(contactMessages.sendAnotherMessageButton)}
        onClick={() => setIsFormSubmitted(false)}
      />
    </Wrapper>

  );
};
